/** Sắp xếp phiếu chờ duyệt: khẩn cấp trước, mới nhất trước */
export const sortPendingFinanceCards = (items = []) =>
  [...items].sort((a, b) => {
    const urgentDiff =
      Number(Boolean(b.is_urgent)) - Number(Boolean(a.is_urgent));
    if (urgentDiff !== 0) return urgentDiff;
    return (
      new Date(b.urgent_at || b.created_at || 0).getTime() -
      new Date(a.urgent_at || a.created_at || 0).getTime()
    );
  });
